import { IBrandCategory } from "../../../Models/IBrandCategory";
import {
    GetAllCategoriesFailureAction,
    GetAllCategoriesInitiateAction,
    GetAllCategoriesSuccessAction,
    GET_ALL_CATEGORIES_FAILURE,
    GET_ALL_CATEGORIES_INITIATE,
    GET_ALL_CATEGORIES_SUCCESS,
    SetLoadingCategoriesAction,
    SET_LOADING_CATEGORIES
} from "../Types/CategoryActionTypes";

export const setLoadingCategories = (loading: boolean): SetLoadingCategoriesAction => ({
    type: SET_LOADING_CATEGORIES,
    data: loading,
});

export const getAllCategoriesInitiate = (): GetAllCategoriesInitiateAction => ({
    type: GET_ALL_CATEGORIES_INITIATE,
    data: null,
});

export const getAllCategoriesSuccess = (
    categories: IBrandCategory[]
): GetAllCategoriesSuccessAction => ({
    type: GET_ALL_CATEGORIES_SUCCESS,
    data: categories,
});

export const getAllCategoriesFailure = (): GetAllCategoriesFailureAction => ({
    type: GET_ALL_CATEGORIES_FAILURE,
    data: null,
});
